/**
 * Returns the Web Worker script as a string for Blob URL creation.
 * This approach is CRA-compatible (no worker-loader or build config changes).
 *
 * The worker receives test data via postMessage, executes user code in an
 * isolated thread, and posts back results. If the code contains an infinite
 * loop, the parent can terminate the worker after a timeout without freezing
 * the main thread.
 */
export const getWorkerCode = (): string => `
  // Override console methods to capture output and send to parent
  ['log', 'warn', 'error', 'info'].forEach(function(method) {
    self.console[method] = function() {
      var args = Array.prototype.slice.call(arguments).map(function(a) {
        try { return typeof a === 'object' ? JSON.stringify(a, null, 2) : String(a); }
        catch(e) { return String(a); }
      });
      self.postMessage({ type: 'console', method: method, args: args });
    };
  });

  self.onmessage = function(e) {
    var data = e.data;
    var code = data.code;
    var functionName = data.functionName;
    var tests = data.tests;
    var outputs = [];

    try {
      // Execute user code once in global scope to define the function
      (0, eval)(code);

      var fn = eval(functionName);

      // Run first test with console active so user sees output once
      if (tests.length > 0) {
        outputs.push(fn.apply(null, tests[0].input));
      }

      // Silence console for remaining test cases to avoid duplicate output
      var noop = function() {};
      self.console.log = noop;
      self.console.warn = noop;
      self.console.error = noop;
      self.console.info = noop;

      for (var i = 1; i < tests.length; i++) {
        var output = fn.apply(null, tests[i].input);
        outputs.push(output);
      }

      self.postMessage({ type: 'success', outputs: outputs });
    } catch (error) {
      self.postMessage({ type: 'error', message: String(error) });
    }
  };
`;
